import { render, staticRenderFns } from "./ParamTypeSelect.vue?vue&type=template&id=13094e8a&scoped=true"
import script from "./ParamTypeSelect.vue?vue&type=script&lang=js"
export * from "./ParamTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./ParamTypeSelect.vue?vue&type=style&index=0&id=13094e8a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13094e8a",
  null
  
)

export default component.exports